import { Box, Card, Grid2 } from '@mui/material';
import React from 'react';

import ContentLoader from '@components/ContentLoader';
import TimelineTree from '@components/TimelineTree/index';

interface TimelineLoaderProps {
  children: React.ReactNode;
  loading: boolean;
  count?: number;
}

const TimelineLoader: React.FC<TimelineLoaderProps> = ({
  children = null,
  loading = false,
  count = 4,
}) => {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!loading) return <>{children}</>;

  return (
    <Box sx={{ display: 'flex' }}>
      <TimelineTree
        nodes={Array.from(Array(count)).map((_key, index) => {
          return (
            <Grid2
              key={`activity-card-loader-${index}}`}
              sx={{
                my: {
                  xs: 3,
                  md: 0,
                },
              }}
            >
              <Card>
                <ContentLoader loading={loading}>{null}</ContentLoader>
              </Card>
            </Grid2>
          );
        })}
      />
    </Box>
  );
};

export default TimelineLoader;
